import React from 'react'

import CourseLaunchSection from '../../components/Course/CourseLaunchSection';
import ModuleDetail from '../modulePages/moduleDetail';
import Page from '../../finwell/pages/Page';

const CourseLaunchPage = () => {
  return (
    <Page showSideMenu={false}>
      <CourseLaunchSection 
        isMobile={false}
      />
    </Page>
  )
}

export default CourseLaunchPage